import { Button, Col, Collapse, Input, message, Popconfirm, Row } from 'antd';
import querystring from "query-string";
import { Component } from "react";
import { connect } from 'react-redux';
import { initMapsState } from "redux_actions/maps.state.action";
import { loadMorpheusSettings } from "redux_actions/morpheus.state.action";
import { calculateClientHeightRatio, notNull } from "utils/utils";
import '../../../asset/style/workflow/advanced-preview-settings-component.css';
import { yBottomChange, yTopChange } from '../../../redux_actions/bloodConfig.action';
import { RegionSelectionConstants } from "../../../redux_constants/region_selection.constant";
import BloodPreviewSlideMap from "../../gammaviewer/BloodPreviewSlideMap";
import { getCanvasComponentNew, getVerticalBrushPanel } from "../slot_component_utils";
import {post, post_response} from "../../../helper/request";

const { Panel } = Collapse;

class BloodPreviewSettingsComp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slideName: (this.props.bloodData || {}).previewResponse.slideName,
            overrideScanRegion: false,
            activePanel: 'general',
        }
        this.advanceUserMode = false //enable this for UI to move to advancedMode on subsequent page open
    }


    componentDidMount = () => {

        //Load Mapsstate
        this.props.dispatch(loadMorpheusSettings());
        this.props.dispatch(initMapsState([{ slideId: this.props.slideId }]));

        let bloodData = (this.props.bloodData || {})

        this.setState({
            slideName: (this.props.bloodData || {}).previewResponse.slideName,
        })
        this.props.dispatch(yTopChange(bloodData.previewResponse.ystart))
        this.props.dispatch(yBottomChange(bloodData.previewResponse.yend))

        //Needed cause regularViewerComponent needs to mount when this page loads to find references
        if(!this.advanceUserMode || bloodData.previewStage !== RegionSelectionConstants.CONFIRMED){
            setTimeout(()=>{this.setState({activePanel: 'blood'})}, 100);
        }

    }

    componentDidUpdate = (prevProps) => {
        let bloodData = (this.props.bloodData)
        let prevbloodData = (prevProps.bloodData)
        if ((bloodData || {}).previewResponse.ystart !== (prevbloodData || {}).previewResponse.ystart && (bloodData || {}).previewResponse.yend !== (prevbloodData || {}).previewResponse.yend) {
            this.props.dispatch(yTopChange(bloodData.previewResponse.ystart))
            this.props.dispatch(yBottomChange(bloodData.previewResponse.yend))
        }
    }

    onScanNameChange = (name) => {
        let old_name = this.state.slideName;
        this.setState({
            slideName: name,
        })
        let val = {
            "slide_id": this.props.slideId,
            "slot_id": this.props.slot_id,
            "slide_name": name,
        }
        let url = `/server/devices/${this.props.device_id}/update_blood_slide_name/`;
        post(url, querystring.stringify(val)).then().catch(err => {
            this.setState({
                slideName: old_name,
            })
        })
    }

    saveChanges = (shouldChangeTab, confirmPreview) => {
        if (this.state.overrideScanRegion) {
            let val = {
                "y_top": this.props.bloodConfig.yTop,
                "y_bottom": this.props.bloodConfig.yBottom,
                "countWBC": 0,
                "slot_id": this.props.slot_id,
            }
            let url = `/server/devices/${this.props.device_id}/update_blood_params/`;
            post_response(url, querystring.stringify(val)).then(res => {
                if (res.status === 200) {
                    this.props.onBloodROIConfirm();
                    message.info("Config Updated");
                    if (confirmPreview) {
                        setTimeout(() => this.props.confirmPreviewSettingChanges(), 500);
                    }
                    if (shouldChangeTab) {
                        this.setState({
                            activePanel: 'general',
                        })
                    }
                }
            }).catch(err => {
                message.error("Failed to update config")
            })
        } else {
            if (confirmPreview) {
                setTimeout(() => this.props.confirmPreviewSettingChanges(), 500);
            }
            if (shouldChangeTab) {
                this.setState({
                    activePanel: 'general',
                })
            }
        }
    }

    overrideScanRegion = () => {
        this.setState({
            overrideScanRegion: true,
        })
    }

    getRegularViewerComponent = () => {
        return (<Row style={{height: '100%'}}>
            <Col span={20} style={{height: '100%'}}>
                <Row style={{height: '95%'}}>
                    {getCanvasComponentNew(this.props.status, this.props.previewCanvasRef, this.props.thresholdCanvasRef,
                        this.props.brushEraserPrevCanvasRef, this.props.regions, this.props.onCanvasUpdate, this.props.allowPainting, this.props.startPainting, this.props.paintCanvas,
                        this.props.stopPainting, this.props.dropDistanceCanvas, this.props.dropDistanceCanvasRef, this.props.focusPointsCanvas,
                        this.props.focusPointsCanvasRef, this.props.preview, this.props.id, this.props.device_id, this.props.brushType,
                        this.props.showBrushOrEraserSize)}
                </Row>
                <Row style={{ height: '5%' }}>
                    <Col className="selected-area-component">
                        Selected Area : {this.props.regionArea} mm2
                    </Col>
                </Row>
            </Col>
            <Col span={4} style={{ height: '100%' }}>
                <Row style={{ height: '74%' }}>
                    {getVerticalBrushPanel(this.props.brushType, this.props.brushSize, this.props.changeBrushType, this.props.movedBrushSizeSlider)}
                    <Row className="side-panel-section">
                        <Col>
                            <span className="arial-font" style={{ marginRight: 10, fontSize: 13 }}><b>Slide Name</b></span>
                            <Input value={this.state.slideName} style={{ width: 260 }} onChange={(e) => this.onScanNameChange(e.target.value)} />
                        </Col>
                    </Row>
                </Row>
                <Row style={{ height: '5%' }}>
                    <Button style={{ width: '90%', marginLeft: '10%', marginRight: '10%' }} onClick={() => this.setState({ activePanel: 'blood' })}>
                        Go back to Monolayer Selection
                    </Button>
                </Row>
                <Row style={{ height: '5%', marginTop: '1%' }}>
                    <Button style={{ width: '90%', marginLeft: '10%', marginRight: '10%' }} type="primary" onClick={this.props.confirmPreviewSettingChanges}>
                        Finalize slide setting
                    </Button>
                </Row>
            </Col>
        </Row>)
    }

    render() {
        let regularViewerComponent;
        let bloodViewerComponent;
        //ymin should always be lesser one 
        //ymax should always be greater one
        let y_min = Math.min(this.props.bloodData.previewResponse.ystart, this.props.bloodData.previewResponse.yend)
        let y_max = Math.max(this.props.bloodData.previewResponse.ystart, this.props.bloodData.previewResponse.yend);

        if (notNull(this.props.mapState) && notNull(this.props.mapState['slide'])) {
            bloodViewerComponent = <div style={{ marginLeft: '20px' }}>
                <BloodPreviewSlideMap {...this.props.mapState}
                                      y_top={y_min} y_bottom={y_max} bloodMapEnable={false}
                                      height={calculateClientHeightRatio(0.64)}
                                      overrideScanRegion={this.state.overrideScanRegion}/>
            </div>
        }

        regularViewerComponent = this.getRegularViewerComponent();

        return (
            <div>
                <Collapse accordion
                    defaultActiveKey={['general']}
                    activeKey={[this.state.activePanel]}
                    onChange={(e) => e.preventDefault()}>
                    <Panel header="Region Select" key="general">
                        <div className={"full-width"} style={{ height: '60vh' }}>
                            {regularViewerComponent}
                        </div>
                    </Panel>

                    <Panel header="Monolayer Area Selection" key="blood">
                        <div style={{ height: '68vh' }}>
                            <Row style={{ height: '95%' }}>
                                <Col span={22} offset={1}>
                                    {bloodViewerComponent}
                                </Col>
                            </Row>
                            <Row style={{ height: '5%' }}>
                                <Col offset={11} span={3}>
                                    {this.state.overrideScanRegion ?
                                        <Button type={"danger"} disabled style={{backgroundColor: "palevioletred"}}>
                                            Manual override Activated
                                        </Button> :
                                        <Popconfirm placement="topLeft"
                                                    title="Do you really want to override auto-detected scan region?"
                                                    onConfirm={this.overrideScanRegion}
                                                    okText="Yes"
                                                    cancelText="No">
                                            <Button type={"danger"}>
                                                Override Scan Region
                                            </Button>
                                        </Popconfirm>
                                    }
                                </Col>
                                <Col offset={1} span={4}>
                                    <Button style={{width: '100%'}} onClick={() => this.saveChanges(true, false)}>
                                        Advance Mode
                                    </Button>
                                </Col>
                                <Col offset={1} span={4}>
                                    <Button style={{width: '100%'}} type="primary" onClick={() => {
                                        this.saveChanges(false, true);
                                    }}>
                                        Finalize slide setting
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Panel>
                </Collapse>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    let { activeMapId } = state.gammaStateReducer;
    let mapState = state.mapsStateReducer[activeMapId];
    return {
        deviceStatus: state.deviceStatusReducer,
        bloodConfig: state.bloodConfigReducer,
        activeMapId,
        mapState
    }
}

export default connect(mapStateToProps)(BloodPreviewSettingsComp);
